/**
 * API 基地址与 Mixed Content 修正
 *
 * 当页面为 HTTPS 时，若 VITE_API_BASE_URL 配成同域的 HTTP，浏览器会拦截请求（Mixed Content）。
 * 在浏览器且与当前页同域时，直接使用 window.location.origin，保证与页面协议一致。
 */

/**
 * 返回修正后的 API 源（仅 origin，无路径）。
 * 若未配置 VITE_API_BASE_URL 则返回空字符串。
 * 浏览器环境下且与当前页同域时，强制使用 window.location.origin，避免 HTTPS 页请求 HTTP。
 */
export function getCorrectedApiOrigin(): string {
  const raw = import.meta.env.VITE_API_BASE_URL
  if (!raw || typeof raw !== 'string') return ''
  const trimmed = raw.trim()
  if (typeof window !== 'undefined') {
    try {
      const url = new URL(trimmed)
      if (url.hostname === window.location.hostname) {
        return window.location.origin
      }
      if (window.location.protocol === 'https:' && url.protocol === 'http:') {
        return `https://${url.host}`
      }
    } catch {
      // 解析失败则返回原值
    }
  }
  return trimmed
}

/**
 * 返回修正后的 API base（含 /api/v1），用于 axios baseURL 或拼接路径。
 * 当前页为 HTTPS 时一律返回相对路径 '/api/v1'，由浏览器解析为当前 origin，避免 Mixed Content。
 */
export function getCorrectedApiBaseUrl(): string {
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    return '/api/v1'
  }
  const origin = getCorrectedApiOrigin()
  return origin ? `${origin}/api/v1` : '/api/v1'
}
